import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15efcb9c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=15efcb9c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15efcb9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15efcb9c')) {
      api.createRecord('15efcb9c', component.options)
    } else {
      api.reload('15efcb9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15efcb9c&scoped=true&", function () {
      api.rerender('15efcb9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/arbitrator/arbInquiry/index.vue"
export default component.exports